import { CartAddEvent } from '@theme/events';

/**
 * The "add a sample" row in the cart. A tap adds that sample to the cart and
 * re-renders the cart items (the drawer and cart page) the same way the
 * product form does.
 */
class CartSampleSlider extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
  }

  /** @param {MouseEvent} event */
  #onClick = async (event) => {
    const button = event.target instanceof Element ? event.target.closest('.cart-samples__add') : null;
    if (!(button instanceof HTMLButtonElement) || button.getAttribute('aria-busy') === 'true') return;

    const variantId = button.dataset.variantId;
    const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
      .map((item) => (item instanceof HTMLElement ? item.dataset.sectionId : null))
      .filter(Boolean);

    button.setAttribute('aria-busy', 'true');
    this.#showError('');

    try {
      const response = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: sectionIds.join(',') }),
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || 'add failed');

      const cart = await fetch(`${Theme.routes.cart_url}.js`).then((res) => res.json());
      document.dispatchEvent(
        new CartAddEvent({}, 'cart-sample-slider', {
          source: 'cart-sample-slider',
          itemCount: cart.item_count,
          variantId,
          sections: data.sections,
        })
      );
    } catch (error) {
      console.error(error);
      this.#showError(this.dataset.errorText || '');
      button.removeAttribute('aria-busy');
    }
  };

  /** @param {string} text */
  #showError(text) {
    const error = this.querySelector('.cart-samples__error');
    if (!(error instanceof HTMLElement)) return;
    error.textContent = text;
    error.hidden = !text;
  }
}

if (!customElements.get('cart-sample-slider')) {
  customElements.define('cart-sample-slider', CartSampleSlider);
}
